export default "__VITE_ASSET__368a99ee__"